<nb-card>
  <nb-card-header>
    <div>
      <button
        [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'info' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('info')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>{{ "common.info" | translate }}</span>
      </button>

      <button
        *ngIf="mode === 'edit'"
        [ngClass]="menu == 'content' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'content' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('content')"
      >
        <nb-icon class="button-icon" icon="file-text-outline"></nb-icon>
        <span>{{ "common.moreDetail" | translate }}</span>
      </button>
    </div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <form *ngIf="menu == 'info'" [formGroup]="diaForm">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="inputFullname" class="label text-primary">{{
              "person.fullName" | translate
            }}</label>
            <input
              type="text"
              nbInput
              fullWidth
              id="inputFullname"
              class="form-control"
              placeholder="{{ 'person.fullName' | translate }}"
              formControlName="fullName"
              [(ngModel)]="supplier.fullName"
            />
          </div>

          <div class="form-group">
            <label for="inputDob" class="label">{{
              "person.dob" | translate
            }}</label>
            <nb-form-field>
              <input
                nbInput
                shape="semi-round"
                placeholder="{{ 'person.dob' | translate }}"
                [nbDatepicker]="dob"
                formControlName="dob"
                [(ngModel)]="supplier.dob"
              />
              <nb-datepicker
                style="width: 120px"
                #dob
                format="dd/MM/yyyy"
              ></nb-datepicker>
            </nb-form-field>
          </div>

          <div class="form-group">
            <label class="label">{{ "common.gender" | translate }}</label>
            <nb-radio-group
              formControlName="gender"
              [(ngModel)]="supplier.gender"
            >
              <nb-radio value="Nam">{{ "person.male" | translate }}</nb-radio>
              <nb-radio value="Nữ">{{ "person.female" | translate }}</nb-radio>
              <nb-radio value="Khác">{{ "common.other" | translate }}</nb-radio>
            </nb-radio-group>
          </div>

          <div class="form-group">
            <label for="inputCardId" class="label">{{
              "person.cardId" | translate
            }}</label>
            <input
              type="text"
              nbInput
              fullWidth
              id="inputCardId"
              class="form-control"
              formControlName="cardId"
              [(ngModel)]="supplier.cardId"
            />
          </div>

          <div class="form-group">
            <label class="label">
              Hình đại diện
              <button
                nbButton
                ghost
                size="none"
                status="danger"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="removeCoverUrl()"
              >
                <nb-icon icon="trash-2-outline"></nb-icon>
              </button>
            </label>
            <ngx-upload-image
              [size]="'tiny'"
              [mode]="'imagekit'"
              [path]="'/supplier/cover'"
              [imageURL]="imageURL"
              (onUploadSuccess)="updateImage($event)"
            ></ngx-upload-image>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="label">
              <label class="text-primary">{{
                "person.mobile" | translate
              }}</label>
              <p class="text-hint">
                Phải nhập số, không có khoảng trắng và đủ 10 hoặc 11 số. vd:
                0912345678, hệ thống mới gửi đúng thông báo
              </p>
            </div>

            <!-- <label for="inputMobile" class="label">{{'person.mobile' | translate}}</label> -->
            <input
              type="tel"
              nbInput
              fullWidth
              id="inputMobile"
              class="form-control"
              placeholder="Di động"
              formControlName="mobile"
              [(ngModel)]="supplier.mobile"
            />
          </div>

          <div class="form-group">
            <div class="label">
              <label class="label">Email</label>
              <p class="text-hint">
                Phải nhập đúng, vd: abc@gmail.com, hệ thống mới gửi đúng thông
                báo
              </p>
            </div>

            <input
              type="email"
              nbInput
              fullWidth
              id="inputEmail"
              class="form-control"
              placeholder="Email"
              formControlName="email"
              [(ngModel)]="supplier.email"
            />
          </div>

          <div class="form-group">
            <label for="inputAddress" class="label">{{
              "person.address" | translate
            }}</label>
            <input
              type="text"
              nbInput
              fullWidth
              id="inputAddress"
              class="form-control"
              placeholder="{{ 'person.address' | translate }}"
              formControlName="address"
              [(ngModel)]="supplier.address"
            />
          </div>

          <div class="form-group">
            <label for="inputTax" class="label">{{
              "person.tax" | translate
            }}</label>
            <input
              type="text"
              nbInput
              fullWidth
              id="inputTax"
              class="form-control"
              placeholder="{{ 'person.tax' | translate }}"
              formControlName="tax"
              [(ngModel)]="supplier.tax"
            />
          </div>

          <div class="form-group">
            <div class="label">
              <label>{{ "common.note" | translate }}</label>
              <p class="text-hint">
                Tóm tắt nội dung ngắn gọn giới thiệu về khách hàng
              </p>
            </div>

            <textarea
              nbInput
              fullWidth
              id="inputDescription"
              class="form-control"
              formControlName="description"
              [(ngModel)]="supplier.description"
            ></textarea>
          </div>

          <div class="form-group">
            <label class="label">{{ "common.tags" | translate }}</label>
            <nb-tag-list (tagRemove)="onTagRemove($event)">
              <nb-tag
                *ngFor="let tree of trees"
                [text]="tree"
                removable
              ></nb-tag>
              <input
                type="text"
                nbTagInput
                (tagAdd)="onTagAdd($event)"
                fullWidth
              />
            </nb-tag-list>
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="menu == 'content'" class="row">
      <div class="col-12">
        <div class="form-group">
          <div class="label">
            <h6 class="text-primary">
              Nội dung chi tiết
              <nb-select
                outline
                shape="round"
                size="small"
                status="info"
                [(ngModel)]="supplier.sourceType"
              >
                <nb-option value="document">Tài liệu</nb-option>
                <nb-option value="video">Video</nb-option>
                <nb-option value="images">Hình ảnh</nb-option>
              </nb-select>
            </h6>
          </div>

          <div *ngIf="supplier.sourceType == 'video'" class="form-group">
            <ngx-view-video [url]="supplier.videoUrl"></ngx-view-video>
            <div class="form-group">
              <label class="label">Đường dẫn URL</label>
              <input
                nbInput
                fullWidth
                placeholder="Nhập liên kết"
                class="form-control"
                [(ngModel)]="supplier.videoUrl"
              />
            </div>
          </div>

          <div *ngIf="supplier.sourceType == 'images'">
            <nb-card>
              <nb-card-header>
                <button
                  nbButton
                  outline
                  fullWidth
                  status="info"
                  size="tiny"
                  [disabled]="submitted"
                  [class.btn-pulse]="submitted"
                  (click)="openGallery()"
                >
                  <nb-icon icon="image-outline"></nb-icon>
                  Chọn hình ảnh
                </button>
              </nb-card-header>
              <nb-card-body class="container">
                <div class="row">
                  <div
                    class="column"
                    *ngFor="let item of imagesUrl; let i = index"
                  >
                    <button
                      nbButton
                      outline
                      fullWidth
                      status="danger"
                      size="tiny"
                      [disabled]="submitted"
                      [class.btn-pulse]="submitted"
                      (click)="deleteImage(item)"
                    >
                      <nb-icon icon="trash-2-outline"></nb-icon>
                    </button>
                    <img [src]="item" style="width: 100%" />
                  </div>
                </div>
              </nb-card-body>
            </nb-card>
          </div>

          <ngx-editor-document
            *ngIf="supplier.sourceType == 'document'"
            [(ngModel)]="supplier.content"
          ></ngx-editor-document>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <div class="label">
            <h6 class="text-primary">{{ "person.contacts" | translate }}</h6>
          </div>
          <ngx-view-persons
            [shopId]="shopId"
            [mode]="'supplier'"
            [refId]="supplier.id"
            [refName]="supplier.fullName"
          ></ngx-view-persons>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      <nb-icon icon="save-outline"></nb-icon>
      {{ "buttons.save" | translate }}
    </button>

    <button
      *ngIf="mode === 'edit'"
      nbButton
      status="danger"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="delete(supplier)"
    >
      <nb-icon icon="trash-2-outline"></nb-icon>
      {{ "buttons.delete" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
